module.exports = __webpack_public_path__ + "img/49.f821f51e.jpg";